import Immutable from 'immutable';
import StackMapConstants from '../../constants/StackMapConstants';

const { REQUEST, SUCCESS, FAILURE, CLOSE } = StackMapConstants;

const initialState = Immutable.Map({
  data: null,
  open: false,
  noResults: false,
  isFetching: false
});

export default function availabilityDetail(state = initialState, action) {
  switch (action.type) {
    case REQUEST: {
      return state.merge({
        open: true,
        isFetching: true
      });
    }

    case SUCCESS: {
      if (action.payload && action.payload.stat === 'OK' && action.payload.results.maps.length > 0) {
        return state.mergeDeep({
          data: action.payload.results,
          isFetching: false
        });
      }

      return state.merge({
        noResults: true,
        isFetching: false
      });
    }

    case FAILURE: {
      return state.merge({
        noResults: true,
        isFetching: false
      });
    }

    case CLOSE: {
      return initialState;
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/ui/StackMapReducer.js